import soundsApi from '@/api/sounds'

let pendingFetch = null

const state = {
  presets: [],
  loaded: false,
}

const getters = {
  getPresets (state) {
    return state.presets
  },
}

const mutations = {
  setPresets (state, presets) {
    state.presets = presets
    state.loaded = true
  },
}

const actions = {
  fetchPresets ({ state, commit }) {
    if (state.loaded) {
      return Promise.resolve(state.presets)
    }

    if (!pendingFetch) {
      pendingFetch = soundsApi.fetchSounds()
        .then((presets) => {
          commit('setPresets', presets)
          return presets
        })
        .finally(() => {
          pendingFetch = null
        })
    }

    return pendingFetch
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
